import React from "react";
import { Button } from "./styles";

interface Props {
  title: string;
  execute: any;
}
export function DarkButton({ execute, title }: Props) {
  return <Button onClick={execute}>{title}</Button>;
}
